import { query } from 'atomic-layout';
import styled from 'styled-components';

import { MaxWidth } from '@/styles/shared/MaxWidth';

export const Container = styled(MaxWidth)``;

export const Wrapper = styled.div`
  padding: 112px;
  max-width: 1280px;
  background: ${props => props.theme.colors.display[0]};
  border-radius: 0px 0px 0px 112px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media ${query({ to: 'xl' })} {
    border-radius: 0px 0px 0px 8vw;
    padding: 8vw;
  }

  @media ${query({ to: '1335' })} {
    margin: 0 24px;
  }

  @media ${query({ to: 'md' })} {
    margin: 0px 16px 0px;
    flex-direction: column;
    align-items: center;
  }
`;

export const ImageContainer = styled.div`
  max-height: 64px;
  max-width: 64px;
  margin-bottom: 24px;
`;

export const FeatureItem = styled.div`
  width: 100%;
  max-width: 309px;

  &:nth-child(2) {
    margin: 0px 24px;
  }

  h3 {
    padding-right: 15px;
    margin-bottom: 8px;
  }

  h4 {
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 28px;
    padding-right: 15px;
  }

  @media ${query({ to: 'md' })} {
    max-width: unset;

    &:nth-child(2) {
      margin: 48px 0px;
    }
  }
`;
